import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

export interface HealthResponse {
  status: string;
  timestamp: string;
  database: string;
}

export interface HelloResponse {
  message: string;
  timestamp: string;
}

export interface UpdateOrganizationNameRequest {
  name: string;
}

export interface UpdateOrganizationNameResponse {
  success: boolean;
  message: string;
  name: string;
}

export interface EnvironmentInfoResponse {
  // Core environment identification
  environment: string;
  timestamp: string;

  // Application version info
  version: string;
  buildTimestamp: string;
  gitHash: string;

  // Server configuration
  server: {
    host: string;
    port: number;
  };

  // Runtime configuration
  config: {
    isProduction: boolean;
    enableTestAuth: boolean;
    frontendUrl: string;
    backendUrl: string;
  };

  // Database configuration
  database: {
    appRoot: string;
    hasGlobalDatabase: boolean;
  };

  // Feature flags
  features?: {
    oauthEnabled: boolean;
    syncEnabled: boolean;
  };
}

@Injectable({
  providedIn: 'root',
})
export class ApiService {
  private http = inject(HttpClient);

  private apiUrl = environment.apiUrl;

  getHealth(): Observable<HealthResponse> {
    return this.http.get<HealthResponse>(`${this.apiUrl}/health`);
  }

  getHello(): Observable<HelloResponse> {
    return this.http.get<HelloResponse>(`${this.apiUrl}/hello`);
  }

  /**
   * Update organization name
   * Requires owner role and online connection
   * Auth token is automatically added by authInterceptor
   */
  updateOrganizationName(
    customerId: string,
    name: string,
  ): Observable<UpdateOrganizationNameResponse> {
    return this.http.put<UpdateOrganizationNameResponse>(`${this.apiUrl}/customers/${customerId}`, {
      name,
    });
  }

  /**
   * Get backend environment information
   * No authentication required - useful for diagnostics
   */
  getEnvironmentInfo(): Observable<EnvironmentInfoResponse> {
    return this.http.get<EnvironmentInfoResponse>(`${this.apiUrl}/environment-info`);
  }
}
